import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppRoutes } from "core/AppRoutes";

/**
 * Stores information of the selected participant for the change logs page
 * */

export enum WhichChangeLogsTable {
  STUDY_PARTICIPANTS_BY_STUDY_SITE_ID,
  STUDY_PARTICIPANT_BY_PARTICIPANT_ID,
  STUDY_PARTICIPANTS_BY_REGISTRY_ID,
  COMPLIANCE_SETTINGS,
  STUDY_DETAILS,
  STUDY_SITE,
  USERS_CDM_OR_SPONSOR_OPS_VIEW,
  USERS_COMPLIANCE_ADMIN_VIEW,
}
export interface ParticipantChangeLogState {
  participantId?: string;
  sponsorParticipantId?: string;
  returnRoute?: string;
  whichChangeLogsTable: WhichChangeLogsTable;
  registryId?: string;
  inTab?: boolean;
}

const initialState: ParticipantChangeLogState = {
  participantId: "",
  returnRoute: AppRoutes.SITE,
  whichChangeLogsTable:
    WhichChangeLogsTable.STUDY_PARTICIPANTS_BY_STUDY_SITE_ID,
  inTab: false,
};

const participantChangeLogStateSlice = createSlice({
  name: "participantChangeLogState",
  initialState,
  reducers: {
    setParticipantChangeLogState: (
      state,
      action: PayloadAction<ParticipantChangeLogState>
    ) => {
      state.participantId = action.payload.participantId;
      state.sponsorParticipantId = action.payload.sponsorParticipantId;
      state.returnRoute = action.payload.returnRoute;
      state.whichChangeLogsTable = action.payload.whichChangeLogsTable;
      state.registryId = action.payload.registryId;
      state.inTab = action.payload.inTab;
    },
  },
});

export const { setParticipantChangeLogState } =
  participantChangeLogStateSlice.actions;

export default participantChangeLogStateSlice.reducer;
